import React from 'react';
import type { LinkBlock } from '@/types/contentBlocks';
import { getFaviconFromUrl } from '@/utils/favicon';

interface LinkBlockProps {
  block: LinkBlock;
  isDarkMode: boolean;
  onLinkClick?: (url: string) => void;
}

export const LinkBlockRenderer: React.FC<LinkBlockProps> = ({ block, isDarkMode, onLinkClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    if (block.isExternal && onLinkClick) {
      e.preventDefault();
      onLinkClick(block.url);
    }
  };

  const favicon = block.isExternal ? getFaviconFromUrl(block.url, 16) : '';

  return (
    <a
      className="text-blue-600 dark:text-blue-400 hover:underline transition-colors font-medium cursor-pointer inline-flex items-center gap-1"
      onClick={handleClick}
      href={block.isExternal ? undefined : block.url}
    >
      {favicon ? (
        <img
          src={favicon}
          alt=""
          className="inline-block w-3.5 h-3.5 rounded-full object-contain mr-0.5"
          onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        />
      ) : null}
      {block.text}
      {block.isExternal && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="inline-block ml-1 opacity-60 flex-shrink-0"
        >
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
          <polyline points="15 3 21 3 21 9"></polyline>
          <line x1="10" y1="14" x2="21" y2="3"></line>
        </svg>
      )}
    </a>
  );
};
